import { Toast } from 'vant';
/**
 * 阿里云 oss
 */

// 引入ali-oss
let OSS = require('ali-oss');

/**
 *  [accessKeyId] {String}：通过阿里云控制台创建的AccessKey。
 *  [accessKeySecret] {String}：通过阿里云控制台创建的AccessSecret。
 *  [bucket] {String}：通过控制台或PutBucket创建的bucket。
 *  [region] {String}：bucket所在的区域， 默认oss-cn-hangzhou。
 */
let client = new OSS({
	region: 'oss-cn-hangzhou',
	endpoint: 'oss-accelerate.aliyuncs.com',
	secure: true,
	accessKeyId: 'LTAI5t6GxGGsav1cQ5gPSZkP',
	accessKeySecret: 'QhnMJdcx5JRN6LP8PJrdWxA1jhVgjo',
	bucket: 'benqgroup'
});

/**
 *  上传文件，大小不能超过5GB
 * @param {string} ObjName OSS的储存路径和文件名字
 * @param {string} fileUrl 本地文件
 *
 * @retruns Promise
 */
export const uploadPic = async (fileUrl, namespace = 'workstype') => {
	var storeAs = `/syhqds2022/${namespace}${process.env.VUE_APP_OSS_NAMESPACE}/${dateFormat(
		'yyyy-MM-dd'
	)}/${new Date().getTime()}`; // 传到oss上的名字
	try {
		let res = await client.put(storeAs, fileUrl);
		// AAA为文件夹， ObjName为文件名字,可以只写名字，就直接储存在 bucket 的根路径
		// console.log(res);
		if (res.res.statusCode === 200) {
			let url = res.res.requestUrls[0];
			//提交信息给后台
			if (!url) {
				Toast('图片上传出错！');
				return false;
			} else {
				// console.log(res);
				Toast('图片上传成功！');
				return url.split('?')[0];
			}
		} else {
			Toast('图片上传出错啦！');
		}

		return false;
	} catch (e) {
		// console.log(e);
		Toast('图片上传出错了！');
		return false;
	}
};

function dateFormat(fmt) {
	let getDate = new Date();
	let o = {
		'M+': getDate.getMonth() + 1,
		'd+': getDate.getDate(),
		'h+': getDate.getHours(),
		'm+': getDate.getMinutes(),
		's+': getDate.getSeconds(),
		'q+': Math.floor((getDate.getMonth() + 3) / 3),
		S: getDate.getMilliseconds()
	};
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length));
	}
	for (let k in o) {
		if (new RegExp('(' + k + ')').test(fmt)) {
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
		}
	}
	if (fmt.includes('NaN')) {
		return '请刷新页面后重试';
	}
	return fmt;
}
